import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import AuthButton from '../AuthButton';
import { cn } from '../../utils/cn';
import abcLogo from '../../assets/abc-logo.webp';

/**
 * Top navigation bar with mobile menu toggle and auth.
 *
 * @param {Object} props
 * @param {function} [props.onMenuClick] - Called when mobile menu button clicked
 * @param {React.RefObject} [props.hamburgerRef] - Ref for the hamburger button (for focus management)
 * @param {string} [props.className] - Additional classes
 */
export function TopBar({
  onMenuClick,
  hamburgerRef,
  className,
}) {
  return (
    <header
      className={cn(
        'flex items-center justify-between h-20 px-4 sm:px-6 bg-white border-b border-neutral-200',
        className
      )}
    >
      {/* Left section: hamburger + logo */}
      <div className="flex items-center gap-3">
        {/* Mobile menu button */}
        <button
          ref={hamburgerRef}
          onClick={onMenuClick}
          className="lg:hidden p-2 -ml-2 rounded-md text-neutral-500 hover:text-neutral-700 hover:bg-neutral-100 transition-colors focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
          aria-label="Open menu"
        >
          <Menu className="h-6 w-6" />
        </button>

        {/* Logo - only visible on mobile (sidebar shows it on desktop) */}
        <Link to="/" className="lg:hidden">
          <img
            src={abcLogo}
            alt="ABC Consulting"
            className="h-10"
          />
        </Link>
      </div>

      {/* Auth button */}
      <div className="flex items-center gap-4">
        <AuthButton />
      </div>
    </header>
  );
}
